'use strict';
const RECCOMENDATIONS = {
    SECTION: {
        MEMBERSHIP: [
            '#product-recommendations-membership',
        ],
        GENUINE: [
            '#accessories-cargo-and-touring-tab',
            '#accessories-protection-tab',
            '#accessories-exterior-styling-tab',
            '#accessories-interior-styling-tab',
            '#accessories-car-care-tab',
            '#accessories-alloy-wheels-tab',
            '#accessories-selected-tab',
            '#accessories-recommended-tab',
            '#accessories-all-tab'
        ],
        SUMMARY: [
            '#product-summary-recommendations-accessories-cross-sell',
            '#product-recommendations-up-sell-pack',
        ],
        PACKS: [
            '#product-recommendations-accessories-pack',
        ],
        MISC: [
            '#product-recommendations-up-sell-pack-config',
        ]
    }
};

/**
 * Configurator recommendation tiles (genuine / pack / membership grids).
 */
const configuratorRecommendation = {
    afterAddReccomendationProductToList: function (config) {
        var $accessoriesRecommendedTabContent = $('#accessories-recommended-tab-content');
        $('.selected-count').each(function (index, element) {
            $(element).text('(' + config.accessoriesRecTypeCount + ')');
        });

        if (config.updateAccessoriesGrid || config.addPackToTile && config.addPackToTile === 'true') {
            if (config.rType === 'selected') {
                var $accessoriesSelectedTab = $('#accessories-selected-tab');
                $accessoriesSelectedTab.trigger('click');
                window.htmx.trigger($accessoriesSelectedTab[0], 'click');
            } else {
                var $accessoriesRecommendedTab = $('#accessories-recommended-tab');
                if ($accessoriesRecommendedTab.parent().hasClass('d-none')) {
                    window.htmx.trigger($('#accessories-all-tab')[0], 'click');
                } else {
                    $accessoriesRecommendedTab.trigger('click');
                    window.htmx.trigger($accessoriesRecommendedTab[0], 'click');
                }
            }
        }

        if ($accessoriesRecommendedTabContent.attr("data-hx-revealed") === 'true') {
            $accessoriesRecommendedTabContent.removeAttr('data-hx-revealed');
        }

        window.htmx.process($accessoriesRecommendedTabContent[0]);
    },
    updateRecommendationParentProduct: function (updatedProductId) {
        var selectors = [];
        selectors = selectors.concat(RECCOMENDATIONS.SECTION.MEMBERSHIP);
        selectors = selectors.concat(RECCOMENDATIONS.SECTION.GENUINE);
        selectors = selectors.concat(RECCOMENDATIONS.SECTION.SUMMARY);
        selectors = selectors.concat(RECCOMENDATIONS.SECTION.PACKS);
        selectors = selectors.concat(RECCOMENDATIONS.SECTION.MISC);

        if (window.ecux.debug.isDebugEnabled()) {
            console.table(
                '[Configurator]',
                '[Reccomendation]',
                '[updateParentProduct]',
                updatedProductId
            );
        }

        $(selectors.join()).each(function () {
            var $this = $(this);
            var $accessoriesRecommendedTab = $('#accessories-recommended-tab');
            var $accessoriesAllTab = $('#accessories-all-tab');

            $this.parents('.recommendation-lazy').parent().removeClass('show');
            var currentHxGetURl = new URL($this.attr('hx-get'));
            currentHxGetURl.searchParams.set('pid', updatedProductId);
            var params = new URLSearchParams(window.location.search);
            var orderId = params.get('orderId') || '';
            var action = params.get('action') || '';
            if (orderId) {
                currentHxGetURl.searchParams.set('orderId', orderId);
            }
            if (action) {
                currentHxGetURl.searchParams.set('action', action);
            }
            $this.attr('hx-get', currentHxGetURl);

            if ($this.attr("data-hx-revealed") === 'true') {
                $this.removeAttr('data-hx-revealed');
            }

            if (!$accessoriesRecommendedTab.parent('.nav-item').hasClass('d-none')) {
                $accessoriesRecommendedTab.trigger('click');
            } else {
                $accessoriesAllTab.trigger('click');
            }

            htmx.process(this);
        });
    },
    setupPageListeners: function () {
        var afterAddReccomendationProductToList = this.afterAddReccomendationProductToList.bind(this);
        $('body').on('reccomendation.cross.sell.count', function (e, data) {
            var $accessoriesRecommendedTab = $('#accessories-recommended-tab');
            var $accessoriesRecommendedTabM = $('#accessories-recommended-tab-m');
            var $accessoriesAllTab = $('#accessories-all-tab');
            var $accessoriesAllTabM = $('#accessories-all-tab-m');
            if (data) {
                var count = parseInt(data);
                if (count > 0) {
                    if ($accessoriesRecommendedTab.parent('.nav-item').hasClass('d-none')) {
                        $accessoriesRecommendedTab.parent('.nav-item').removeClass('d-none')
                    }

                    $accessoriesRecommendedTabM.parent('.nav-item').removeClass('d-none');
                    $accessoriesRecommendedTab.trigger('click');
                }

                if (count === 0) {
                    $accessoriesRecommendedTab.parent('.nav-item').addClass('d-none');
                    $accessoriesRecommendedTabM.parent('.nav-item').addClass('d-none');
                    $('.accessories-category-select option[value="accessories-recommended-tab"]').remove();
                    $('.accessories-category-select select').val('accessories-all-tab');
                    $accessoriesAllTab.trigger('click');
                    $accessoriesAllTabM.trigger('click');
                    window.htmx.trigger('#accessories-all-tab', 'click');
                    window.htmx.trigger('#accessories-all-tab-m', 'click');
                }
            }

        });

        $('body').on('product:afterAttributeSelect', function (el, response) {
            afterAddReccomendationProductToList({
                updateAccessoriesGrid: true
            });
        });
    },

    /**
     * Pack radios cannot natively deselect on re-click. Snapshot checkedness on
     * pointerdown, defer DOM mutate until successful HTMX, skip siblings still in flight.
     * Namespaced `.accessoriesPack` so re-init is idempotent.
     */
    initPackSelection: function () {
        const packRadioSel = '.recommendation-tiles input[name="accessories_pack"]';
        const eventNamespace = '.accessoriesPack';

        $(document)
            .off(eventNamespace)
            .on('pointerdown' + eventNamespace, '.recommendation-tiles .recommendation-tile__action', function () {
                var $input = $(this).find('input[name="accessories_pack"]').first();

                if ($input.length) {
                    $input.data('wasChecked', $input.prop('checked'));
                }
            })
            .on('click' + eventNamespace, packRadioSel, function () {
                var $radio = $(this);

                $radio.data('pendingDeselect', !!$radio.data('wasChecked'));
                $radio.removeData('wasChecked');
            })
            .on('htmx:beforeRequest' + eventNamespace, packRadioSel, function () {
                $(this).data('htmxPending', true);
            })
            .on('htmx:afterRequest' + eventNamespace, packRadioSel, function (e) {
                var detail = (e.originalEvent && e.originalEvent.detail) || {};
                var requestSucceeded = detail.successful;

                if (requestSucceeded === undefined && detail.xhr) {
                    requestSucceeded = detail.xhr.status >= 200 && detail.xhr.status < 300;
                }

                var $radio = $(this);

                $radio.removeData('htmxPending');

                if (!requestSucceeded) {
                    $radio.removeData('pendingDeselect');

                    return;
                }

                if ($radio.data('pendingDeselect')) {
                    $radio.prop('checked', false);
                }

                $radio.removeData('pendingDeselect');

                $(packRadioSel).each(function () {
                    var $packRadio = $(this);

                    if ($packRadio.data('htmxPending') && !$packRadio.is($radio)) {
                        return;
                    }

                    if ($packRadio.prop('checked')) {
                        $packRadio.attr('checked', 'checked').val('false');
                    } else {
                        $packRadio.removeAttr('checked').val('on');
                    }
                });
            });
    },

    init: function () {
        this.setupPageListeners();
        this.initPackSelection();
    }
};

function syncAccessoriesCategorySelect(tabId) {
    var select = document.querySelector('.accessories-category-select select');

    if (select && tabId && select.querySelector('option[value="' + tabId + '"]')) {
        select.value = tabId;
    }
}

$(document).on('shown.bs.tab', '#accessories-tab [data-toggle="tab"]', function () {
    syncAccessoriesCategorySelect(this.id);
});

var accessoriesMobileQuery = window.matchMedia('(max-width: 599.98px)');

function syncActiveAccessoriesTab(event) {
    if (!event.matches) return;

    var activeTab = document.querySelector('#accessories-tab .nav-link.active');

    if (activeTab) {
        syncAccessoriesCategorySelect(activeTab.id);
    }
}

if (accessoriesMobileQuery.addEventListener) {
    accessoriesMobileQuery.addEventListener('change', syncActiveAccessoriesTab);
} else {
    accessoriesMobileQuery.addListener(syncActiveAccessoriesTab);
}

syncActiveAccessoriesTab(accessoriesMobileQuery);

$(document).on('change', '.accessories-category-select select', function () {
    var tab = document.getElementById(this.value);

    if (tab) {
        tab.click();
    }
});

$(document).on('click', '.accessories-show-more', function () {
    var input = document.getElementById(this.getAttribute('data-show-more'));

    if (input) {
        input.checked = true;
    }
});

module.exports = configuratorRecommendation;
